import 'css-chunksrc/client/scenes/zone/projects/project/styles.scss';export default {
  "project": "_project_gu7up_1",
  "name": "_name_gu7up_11",
  "iconBox": "_iconBox_gu7up_17",
  "icon": "_icon_gu7up_17"
};